export default "__VITE_ASSET__CvhERRca__"